import React from 'react';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import InputSubmit from 'brastrap/common/field-input-submit/FieldInputSubmit';
import Button from 'brastrap/common/button-link/ButtonLink';
import type { Locate as Props } from './locate.types';
import { applyModifiers } from '../../utils';

const messages = defineMessages({
  browse: { id: 'locate.browse', defaultMessage: 'Browse a list of our shops' },
  button: { id: 'locate.button', defaultMessage: 'Go' },
  or: { id: 'locate.or', defaultMessage: 'or' },
  placeholder: {
    id: 'locate.placeholder',
    defaultMessage: 'Enter town/postcode',
  },
});

const Locate = ({
  intl: { formatMessage },
  location,
  modifiers,
  onBrowse,
  onSubmit,
  size,
  postcodeLookUp,
}: Props) => {
  const sizeModifiers = size ? [size] : [];

  const button = {
    label: formatMessage(messages.button),
    modifiers: sizeModifiers,
    submit: true,
  };

  const input = {
    ...location,
    modifiers: sizeModifiers,
    placeholder: formatMessage(messages.placeholder),
    type: 'search',
  };

  const browse = {
    label: formatMessage(messages.browse),
    modifiers: [...sizeModifiers, 'filled'], // Browse button is the only one that should be filled.
    onClick: onBrowse,
    url: '/shops/all/',
  };

  return (
    <div className={applyModifiers('c-locate', modifiers)}>
      {postcodeLookUp && (
        <div className="c-locate__postcode-lookup">
          <InputSubmit
            {...{ button, input }}
            modifiers={['search']}
            onSubmit={onSubmit}
          />
          <span className="c-locate__postcode-lookup__or">
            <FormattedMessage {...messages.or} />
          </span>
        </div>
      )}
      <Button {...browse} />
    </div>
  );
};

Locate.defaultProps = {
  onBrowse: () => {},
  modifiers: [],
  size: 'large',
};

export default injectIntl(Locate);
